import { Box, MenuItem, Select, Typography } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useTranslation } from "react-i18next";

export type SortOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

export type SortFieldProps = {
  label?: string;
  value: string;
  onChange: (event: SelectChangeEvent<string | string[]>) => void;
  options: SortOption[];
};

const SortField = ({ label, value, onChange, options }: SortFieldProps) => {
  const { t } = useTranslation();
  const labelText = label ?? t("talentProfile:sortLabel");

  return (
    <Box display="flex" alignItems="center" gap="8px">
      <Typography variant="secondary" sx={{ whiteSpace: "nowrap" }}>
        {labelText}
      </Typography>
      <Select
        value={value}
        onChange={onChange}
        variant="standard"
        sx={{
          fontSize: "14px",
          backgroundColor: "transparent !important",
          "&.MuiInputBase-root": {
            backgroundColor: "transparent !important",
          },
          "& .MuiSelect-select": {
            paddingTop: 0,
            paddingBottom: 0,
            lineHeight: "1.43",
            backgroundColor: "transparent !important",
          },
          "&:before": { borderBottom: "none" },
          "&:after": { borderBottom: "none" },
          "&:hover:not(.Mui-disabled):before": { borderBottom: "none" },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default SortField;
